import { Config } from '@leverege/plugin';
import I18N from '@leverege/i18n';
const {
  t
} = I18N.ns('molten.dataViewers.map.Satellite');
export default {
  id: 'molten.mapDataViewer.Satellite',
  matches: {
    client: 'MapDataViewer',
    use: 'bottomRightActionBar'
  },
  layout: {
    sort: 'satellite'
  },
  handles: context => {
    const style = context?.clientProps?.settings?.mapStyle;
    return style !== 'satellite';
  },
  appearance: ({
    context
  }) => {
    return {
      name: t('name'),
      prefer: 'icon',
      checkStyle: 'toggle',
      checked: context?.clientProps?.overrideModel?.mapStyle === 'satellite',
      icon: Config.get('MapScreen', 'satelliteIcon', 'https://molten-ui-assets.storage.googleapis.com/icon-satellite.svg')
    };
  },
  perform: ({
    context
  }) => {
    const {
      clientProps
    } = context;
    const {
      overrides,
      overrideModel,
      dataViewerId
    } = clientProps;
    if (overrideModel == null || overrideModel?.mapStyle !== 'satellite') {
      overrides.set(dataViewerId, 'mapStyle', 'satellite');
    } else {
      overrides.set(dataViewerId, 'mapStyle', null);
    }
  }
};